// src/components/lessons/renderers/TrapRenderer.jsx
import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';

const TrapRenderer = ({ block, isMobile }) => {
  const [isHovered, setIsHovered] = useState(false);
    const processText = (text) => {
    if (typeof text !== 'string') return text;
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? (
        <strong key={index} style={{
          fontWeight: '700',
          color: '#000000',
          background: '#FFFFFF',
          padding: '0.125rem 0.375rem',
          borderRadius: '0.25rem',
          border: '1px solid #E5E7EB'
        }}>
          {part}
        </strong>
      ) : part;
    });
  };
  return (
    <div
      style={{
        background: '#FFFFFF',
        border: '2px solid #000000',
        borderRadius: '0.75rem',
        padding: isMobile ? '1.25rem' : '1.5rem',
        marginBottom: '1.5rem',
        boxShadow: isHovered ? '0 8px 24px rgba(0, 0, 0, 0.12)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: isHovered ? 'translateY(-2px)' : 'translateY(0)'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Red accent bar at top (for warnings) */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: '#000000'
      }} />

      {/* Title with Emoji */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        marginBottom: '1rem',
        marginTop: '0.5rem'
      }}>
        {/* Emoji */}
        {block.emoji && (
          <div style={{
            fontSize: '1.5rem',
            lineHeight: 1,
            flexShrink: 0
          }}>
            {block.emoji}
          </div>
        )}

        {/* Title */}
        {block.title && (
          <h5 style={{
            fontSize: isMobile ? '1rem' : '1.1rem',
            fontWeight: '700',
            color: '#000000',
            margin: 0,
            flex: 1
          }}>
            {block.title}
          </h5>
        )}

        {/* Alert Icon */}
        <div style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          background: '#000000',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          transition: 'transform 0.3s ease',
          transform: isHovered ? 'rotate(12deg) scale(1.1)' : 'rotate(0deg) scale(1)'
        }}>
          <AlertTriangle size={16} style={{ color: '#3A86FF' }} />
        </div>
      </div>

      {/* Description */}
      {block.description && (
        <p style={{
          fontSize: isMobile ? '0.9rem' : '0.95rem',
          color: '#000000',
          margin: 0,
          marginBottom: block.tip ? '1rem' : 0,
          lineHeight: '1.7',
          opacity: 0.85
         }}>
    {processText(block.description)}
  </p>
)}

      {/* Tip */}
      {block.tip && (
        <div style={{
          background: '#000000',
          padding: isMobile ? '1rem' : '1.25rem',
          borderRadius: '0.5rem'
        }}>
          <p style={{
            fontSize: isMobile ? '0.85rem' : '0.9rem',
            color: '#FFFFFF',
            margin: 0,
            marginBottom: '0.75rem',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <div style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              background: '#3A86FF'
            }} />
            💡 Solution:
          </p>
          <p style={{
            fontSize: isMobile ? '0.9rem' : '0.95rem',
            color: '#FFFFFF',
            margin: 0,
            fontWeight: '500',
            lineHeight: '1.6',
            opacity: 0.95
          }}>
  {processText(block.tip)}
</p>
        </div>
      )}
            {/* Handle 'fix' field */}
          {block.fix && (
            <div style={{
              padding: '12px',
              backgroundColor: '#e8f5e9',
              borderRadius: '6px',
              borderLeft: '3px solid #4caf50'
            }}>
              <div style={{ fontWeight: 'bold', marginBottom: '4px', color: '#2e7d32' }}>
                💡 Solution:
              </div>
              <div>{processText(block.fix)}</div>
            </div>
          )}

          {/* Handle 'example' field */}
          {block.example && (
            <div style={{
              padding: '12px',
              backgroundColor: '#f5f5f5',
              borderRadius: '6px',
              borderLeft: '3px solid #2196F3',
              fontStyle: 'italic'
            }}>
              <div style={{ fontWeight: 'bold', marginBottom: '4px', color: '#1976d2' }}>
                📝 Example:
              </div>
              <div>{processText(block.example)}</div>
            </div>
          )}
      {/* Decorative corner dot */}
      {isHovered && (
        <div style={{
          position: 'absolute',
          bottom: '12px',
          right: '12px',
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          background: '#3A86FF',
          animation: 'pulse 1.5s ease-in-out infinite'
        }} />
      )}
    </div>
  );
};

export default TrapRenderer;